<template>
    <div class="mb-3.5 text-indian-khaki-900">
        <h1 class="mb-1 text-3xl">{{ title }}</h1>
        <div
            v-if="description"
            class="relative max-h-[85px] overflow-hidden"
            :class="{ '!max-h-full': descriptionOpen }">
            <div class="content-block text-sm font-medium" v-html="description"></div>
            <div
                v-if="!descriptionOpen"
                class="absolute -bottom-4 left-0 h-20 w-full bg-gradient-to-t from-white to-transparent"></div>
        </div>
        <button
            v-if="description"
            @click="descriptionOpen = invokeDescription(descriptionOpen)"
            :class="{ 'mt-1.5': descriptionOpen }"
            class="btn-read-more mx-auto flex items-center gap-2 text-sm font-bold text-[#147CB5]">
            <template v-if="!descriptionOpen">{{ $snippets['headless.plp.readMore'] }}</template>
            <template v-else>{{ $snippets['headless.plp.readLess'] }}</template>
            <ChevronDownIcon :class="{ 'rotate-180': descriptionOpen }" class="size-5" />
        </button>
    </div>
</template>

<script setup lang="ts">
    import { ChevronDownIcon } from '@heroicons/vue/24/solid';

    const props = defineProps({
        title: String,
        description: String,
    });

    const descriptionOpen = ref(false);

    const invokeDescription = (state: boolean) => !state;
</script>

<style scoped>
    .btn-read-more {
        font-family: 'Inter', 'sans-serif';
    }
</style>
